/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as GraphLabelNonInteractive } from './graph-label-non-interactive.story';
export { default as GraphLabelTypes } from './graph-label-types.story';
export { default as GraphLabelFluid } from './graph-label-fluid.story';
export { default as GraphLabelSizes } from './graph-label-sizes.story';
export { default as GraphLabelDisabled } from './graph-label-disabled.story';
export { default as GraphLabelSelected } from './graph-label-selected.story';
export { default as GraphLabelColor } from './graph-label-color.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import GraphLabelColorSourceRaw from './graph-label-color.story?raw';
import GraphLabelDisabledSourceRaw from './graph-label-disabled.story?raw';
import GraphLabelFluidSourceRaw from './graph-label-fluid.story?raw';
import GraphLabelNonInteractiveSourceRaw from './graph-label-non-interactive.story?raw';
import GraphLabelSelectedSourceRaw from './graph-label-selected.story?raw';
import GraphLabelSizesSourceRaw from './graph-label-sizes.story?raw';
import GraphLabelTypesSourceRaw from './graph-label-types.story?raw';

export const GraphLabelNonInteractiveSource = removeLicenseHeader(
  GraphLabelNonInteractiveSourceRaw,
);

export const GraphLabelFluidSource = removeLicenseHeader(
  GraphLabelFluidSourceRaw,
);
export const GraphLabelSizesSource = removeLicenseHeader(
  GraphLabelSizesSourceRaw,
);
export const GraphLabelDisabledSource = removeLicenseHeader(
  GraphLabelDisabledSourceRaw,
);
export const GraphLabelSelectedSource = removeLicenseHeader(
  GraphLabelSelectedSourceRaw,
);
export const GraphLabelColorSource = removeLicenseHeader(
  GraphLabelColorSourceRaw,
);
export const GraphLabelTypesSource = removeLicenseHeader(
  GraphLabelTypesSourceRaw,
);
